function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M25.332 41.5571V22.4424C25.3324 22.2033 25.3971 21.9686 25.5194 21.7631C25.6416 21.5575 25.8169 21.3887 26.0269 21.2741C26.2368 21.1596 26.4737 21.1037 26.7127 21.1122C26.9518 21.1207 27.1841 21.1933 27.3854 21.3224L42.2547 30.8771C42.443 30.9977 42.5979 31.1638 42.7052 31.36C42.8125 31.5562 42.8687 31.7762 42.8687 31.9998C42.8687 32.2234 42.8125 32.4434 42.7052 32.6396C42.5979 32.8358 42.443 33.0018 42.2547 33.1224L27.3854 42.6798C27.1841 42.8089 26.9518 42.8816 26.7127 42.8901C26.4737 42.8986 26.2368 42.8426 26.0269 42.7281C25.8169 42.6136 25.6416 42.4447 25.5194 42.2391C25.3971 42.0336 25.3324 41.7989 25.332 41.5598V41.5571Z",
  fill: "white"
});
var _ref3 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M2.66797 31.9998C2.66797 15.7998 15.8013 2.6665 32.0013 2.6665C48.2013 2.6665 61.3346 15.7998 61.3346 31.9998C61.3346 48.1998 48.2013 61.3332 32.0013 61.3332C15.8013 61.3332 2.66797 48.1998 2.66797 31.9998ZM32.0013 6.6665C25.2825 6.6665 18.8389 9.33554 14.0879 14.0865C9.33701 18.8374 6.66797 25.281 6.66797 31.9998C6.66797 38.7187 9.33701 45.1623 14.0879 49.9132C18.8389 54.6641 25.2825 57.3332 32.0013 57.3332C38.7201 57.3332 45.1638 54.6641 49.9147 49.9132C54.6656 45.1623 57.3346 38.7187 57.3346 31.9998C57.3346 25.281 54.6656 18.8374 49.9147 14.0865C45.1638 9.33554 38.7201 6.6665 32.0013 6.6665Z",
  fill: "white"
});
const SvgPlay = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlay, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/play.ac52a684.svg";
export { ForwardRef as ReactComponent };